module.exports = new __parcel__URL__("artifact_0008.0f642e73.png").toString();